import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from 'redux/actions/index';

import './DeleteAccount.scss';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import { AWSCognitoInstance } from 'services/AWSCognito';

function DeleteAccount({ user, actions }) {
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(null);

  const showTitle = () => (
    <div className="delete-account-title">Your course has ended</div>
  );

  const showDescription = () => (
    <div className="delete-account-description">
      You are not enrolled in any future courses. Would you like to keep your
      account active?
    </div>
  );

  const showDetails = () => {
    if (user?.settings?.deleteAccount?.secondWarningSentAt) {
      const date = moment(
        user.settings.deleteAccount.secondWarningSentAt,
      ).format('MM-DD-YYYY');

      return (
        <div className="delete-account-details">
          We've sent a second reminder email on <b>{date}</b> that your account
          will be deleted <b>tomorrow</b>.
        </div>
      );
    }

    if (user?.settings?.deleteAccount?.firstWarningSentAt) {
      const date = moment(
        user.settings.deleteAccount.firstWarningSentAt,
      ).format('MM-DD-YYYY');
      return (
        <div className="delete-account-details">
          We've sent a reminder email on <b>{date}</b> that your account will be
          deleted in <b>30 days</b>.
        </div>
      );
    }

    return null;
  };

  const showScheduledDate = () => {
    if (user?.settings?.deleteAccount?.scheduledAt) {
      const date = moment(user.settings.deleteAccount.scheduledAt).format(
        'MM-DD-YYYY',
      );

      return (
        <div className="delete-account-details">
          Your account is scheduled to delete at <b>{date}</b>.
        </div>
      );
    }

    return null;
  };

  const keepMyAccount = async () => {
    try {
      await actions.keepUserAccount();
    } catch (error) {}
  };

  const showButtons = () => (
    <div className="d-flex align-items-center">
      <RectangularButton darkButton onClick={() => keepMyAccount()}>
        Yes, keep my account active
      </RectangularButton>
      <RectangularButton
        darkButton
        className="red ml-4"
        onClick={() => setShowDeleteConfirmation(true)}
      >
        No, delete my account and all my data
      </RectangularButton>
    </div>
  );

  const renderDeleteConfirmation = () => {
    if (!showDeleteConfirmation) {
      return null;
    }

    return (
      <DeleteAccountConfirmation
        username={user.username}
        actions={actions}
        onClose={() => setShowDeleteConfirmation(null)}
      />
    );
  };

  return (
    <div className="delete-account container">
      {showTitle()}
      {showDescription()}
      {showDetails()}
      {showScheduledDate()}
      {showButtons()}
      {renderDeleteConfirmation()}
    </div>
  );
}

function DeleteAccountConfirmation({ username, actions, onClose }) {
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmationMessage, setShowConfirmationMessage] = useState(false);

  async function deleteUser() {
    setIsLoading(true);

    try {
      await actions.anonymizeUserData();

      setShowConfirmationMessage(true);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  function logout() {
    AWSCognitoInstance.logout(username);
    actions.manualLogout('/');
  }

  return (
    <Modal show className="delete-account-modal">
      <Modal.Header
        closeButton={!showConfirmationMessage}
        onHide={() => {
          if (!showConfirmationMessage) {
            onClose();
          }
        }}
      >
        <Modal.Title>Delete account</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showConfirmationMessage ? (
          <div>
            Your account and data will be deleted and you will be notified via
            an email.
          </div>
        ) : (
          <div>
            Are you sure you want to delete your account and data? This will
            delete your user and all associated data. This action cannot be
            reversed.
          </div>
        )}
      </Modal.Body>
      {!showConfirmationMessage ? (
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            {isLoading ? (
              <div
                className="fa fa-spin fa-spinner text-primary"
                style={{ fontSize: '18px' }}
              />
            ) : (
              <>
                <RectangularButton onClick={() => onClose()} noBorder>
                  No, keep account
                </RectangularButton>
                <RectangularButton
                  onClick={() => deleteUser()}
                  className="danger-button"
                  darkButton
                >
                  Yes, delete account
                </RectangularButton>
              </>
            )}
          </div>
        </Modal.Footer>
      ) : (
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <RectangularButton onClick={() => logout()}>
              Logout
            </RectangularButton>
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user ? state.user.user : null,
  };
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccount);
